import { Link } from "react-router-dom";
import { Wrench, PackageOpen, Disc, BatteryCharging, Truck, Globe } from "lucide-react";

/**
 * "Our Services" section — 6 services as per new business model.
 * Circle-icon cards on white, matching the reference mockup exactly.
 */
const SERVICES = [
  {
    icon: <Wrench size={30} />,
    title: "Quality Used Auto Parts",
    sub: "Wide range of tested used parts for most makes & models.",
    href: "/parts?condition=Used",
    testid: "svc-used-parts",
  },
  {
    icon: <PackageOpen size={30} />,
    title: "New Spare Parts",
    sub: "Genuine new parts with quality you can rely on.",
    href: "/parts?condition=New",
    testid: "svc-new-parts",
  },
  {
    icon: <Disc size={30} />,
    title: "Tyres & Wheels",
    sub: "All sizes & brands for cars, SUVs & vans.",
    href: "/tyres",
    testid: "svc-tyres-wheels",
  },
  {
    icon: <BatteryCharging size={30} />,
    title: "Batteries",
    sub: "Top quality batteries for all vehicle types.",
    href: "/parts?category=electrical",
    testid: "svc-batteries",
  },
  {
    icon: <Truck size={30} />,
    title: "Recovery Truck Services",
    sub: "24/7 reliable recovery services across the UK.",
    href: "/recovery",
    testid: "svc-recovery",
  },
  {
    icon: <Globe size={30} />,
    title: "UK Shipping",
    sub: "We ship parts locally & nationwide with care.",
    href: "/contact",
    testid: "svc-shipping",
  },
];

const HomeServices = () => (
  <section className="py-20" data-testid="home-services">
    <div className="vd-container">
      <div className="text-center mb-14">
        <h2 className="vd-services-heading">
          OUR <span className="vd-red">SERVICES</span>
        </h2>
        <span className="vd-red-underline" aria-hidden="true" />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
        {SERVICES.map((s) => (
          <Link to={s.href} key={s.title} className="vd-service-card" data-testid={s.testid}>
            <span className="vd-service-icon">{s.icon}</span>
            <div className="vd-service-title">{s.title}</div>
            <p className="vd-service-sub">{s.sub}</p>
          </Link>
        ))}
      </div>
    </div>

    <style>{`
      .vd-services-heading { font-size: clamp(28px, 3.8vw, 40px); font-weight: 900; letter-spacing: 0.06em; margin: 0; }
      .vd-services-heading .vd-red { color: var(--primary-red); }
      .vd-red-underline { display: inline-block; width: 90px; height: 3px; background: var(--primary-red); border-radius: 2px; margin-top: 8px; }
      .vd-service-card {
        display: flex; flex-direction: column; align-items: center; text-align: center;
        padding: 26px 18px 22px; border: 1px solid var(--border-color); border-radius: 8px;
        background: var(--card-bg); transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;
      }
      .vd-service-card:hover { transform: translateY(-4px); box-shadow: 0 12px 28px rgba(0,0,0,0.08); border-color: rgba(230,0,0,0.5); }
      .vd-service-icon {
        display: inline-flex; align-items: center; justify-content: center;
        width: 72px; height: 72px; border-radius: 999px;
        border: 2px solid var(--primary-red); color: var(--primary-red);
        margin-bottom: 14px;
      }
      .vd-service-title { font-weight: 800; font-size: 14px; letter-spacing: 0.02em; margin-bottom: 8px; color: var(--text-heading); line-height: 1.25; text-transform: uppercase; min-height: 34px; }
      .vd-service-sub { font-size: 12.5px; color: var(--text-muted); line-height: 1.45; margin: 0; }
    `}</style>
  </section>
);

export default HomeServices;
